/**
 * dataexports service
 */

import Resource from './resource'

export default new Resource('dataexports')



// WEBPACK FOOTER //
// ./src/libraries/services/dataexports.js